import React, {
  useRef,
  useEffect,
  useState,
  useMemo,
  lazy,
  Suspense,
} from "react";
import formatDate from "../../common/Formatdate";
import Tripstartenddetails from "./Tripstartenddetails";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import ChatIcon from "@mui/icons-material/Chat";
import { alpha } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import CircularProgress from "@mui/material/CircularProgress";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import formatDateAndTime from "../../common/formatDateAndTime";
import Bookinglineitems from "./Bookinglineitems";
import Assignagents from "./Assignagents";
import Swapvehicle from "./Swapvehicle";
import fetchcity from "../../common/fetchcity";
import Cancelbooking from "./Cancelbooking";
import Extension from "./Extension";
import Reschedule from "./Reschedule";
import Initiatebooking from "./Initiatebooking";
import Summary from "./Summary";
import Customerdetails from "./Customerdetails";
import Comments from "./Comments";
import Timeline from "./Timeline";
import Nrks from "./Nrks";
import Addtransactions from "./Addtransactions";
import getactions from "../../common/getactions";
import { BlinkBlur } from "react-loading-indicators";
import Updatedetails from "./Updatedetails";
import Fleetbookingcomments from "./Fleetbookingcomments";
import toast from "react-hot-toast";
import VehicleDocuments from "../vehicledashboard/Vehicledocuments";
import Vehicledocuments from "./Vehicledocuments";
import { mapBookingToSemanticContext } from "./aiSemanticMapper";
import FleetChat from "./FleetChat";
import Aigif from "../../assets/ai.gif";

const TripStartImagesTab = lazy(() => import("./Tripstartimagestab"));
const TripEndImagesTab = lazy(() => import("./Tripendimagestab"));
const CustomerTripImages = lazy(() => import("./Customertripimages"));

const SectionTable = ({ title, rows, highlightLabel }) => {
  const rowRefs = useRef({});
  const [highlightedRows, setHighlightedRows] = useState({});

  React.useEffect(() => {
    if (highlightLabel && rowRefs.current[highlightLabel]) {
      setHighlightedRows((prev) => ({ ...prev, [highlightLabel]: true }));
      rowRefs.current[highlightLabel]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      const timer = setTimeout(() => {
        setHighlightedRows((prev) => ({ ...prev, [highlightLabel]: false }));
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [highlightLabel]);

  return (
    <div className="overflow-hidden rounded-lg shadow mb-8">
      <table className="w-full text-left bg-white">
        <thead className="bg-[#34495e] text-white">
          <tr>
            <th className="px-6 py-4" colSpan={2}>
              {title}
            </th>
          </tr>
        </thead>
        <tbody className="text-sm divide-y divide-gray-200">
          {rows.map(([label, value], idx) => {
            const isHighlighted =
              highlightedRows[label] && label === highlightLabel;
            return (
              <tr
                key={idx}
                ref={(el) => {
                  if (label) rowRefs.current[label] = el;
                }}
                className={`${isHighlighted ? "bg-yellow-100 transition-colors duration-1000" : ""}`}
              >
                <td className="font-semibold px-6 py-3 text-[#2c3e50] w-1/3">
                  {label}
                </td>
                <td className="px-6 py-3 text-[#34495e]">{value}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const GEMINI_API_KEY = "AQ.Ab8RN6LoE5rMipKXeFi6zA8Uw2CX_PqBEzpvLOjL8WtjdsyPzQ";

const InfoTable = ({ title, rows, highlightLabel }) => {
  const rowRefs = useRef({});
  const [highlightedRows, setHighlightedRows] = useState({});

  React.useEffect(() => {
    if (highlightLabel && rowRefs.current[highlightLabel]) {
      setHighlightedRows((prev) => ({ ...prev, [highlightLabel]: true }));
      rowRefs.current[highlightLabel]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      }); 
      const timer = setTimeout(() => {
        setHighlightedRows((prev) => ({ ...prev, [highlightLabel]: false }));
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [highlightLabel]);

  return (
    <div className="overflow-hidden rounded-lg shadow mb-8">
      <table className="w-full text-left bg-white">
        <thead className="bg-[#34495e] text-white">
          <tr>
            <th className="px-6 py-4" colSpan={2}>
              {title}
            </th>
          </tr>
        </thead>
        <tbody className="text-sm divide-y divide-gray-200">
          {rows.map(([label, value], idx) => {
            const isHighlighted =
              highlightedRows[label] && label === highlightLabel;
            return (
              <tr
                key={idx}
                ref={(el) => {
                  if (label) rowRefs.current[label] = el;
                }}
                className={`${isHighlighted ? "bg-yellow-100 transition-colors duration-1000" : ""}`}
              >
                <td className="font-semibold px-6 py-3 text-[#2c3e50] w-1/3">
                  {label}
                </td>
                <td className="px-6 py-3 text-[#34495e]">{value}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const Bookingdetailstab = ({
  selectedRow,
  setSelectedRow,
  setOpenTab,
  getAllBookings,
  getAllHubsListData,
  setCity,
  setHub,
  setDateFilterBy,
  setBookingStatus,
  setSelectedSearchButton,
  setSearchValues,
  setActiveItem,
}) => {
  const queryBookingid = new URLSearchParams(window.location.search).get(
    "bookingid",
  );
  const dbId = new URLSearchParams(window.location.search).get(
    "id",
  );
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  let vehicleBodyType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBodyType;
  let fuelType = JSON.parse(localStorage.getItem("catalogValues"))?.fuelType;
  let transmissionType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.transmissionType;
  let vehicleStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleStatus;
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  let profile = JSON.parse(localStorage.getItem("profile"));
  let bookingTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;
  const resourceTypes =
    JSON.parse(localStorage.getItem("catalogValues"))?.resourceTypes || {};
  const [activeTab, setActiveTab] = useState(null);
  const [summaryDetails, setSummaryDetails] = useState(null);
  const [bookingId, setBookingId] = useState(null);
  const [vehicleDetails, setVehicleDetials] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState([]);
  const [paymentDetailsData, setPaymentDetailsData] = useState(null);
  const [tripStartDetails, setTripStartDetails] = useState([]);
  const [tripEndDetails, setTripEndDetails] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [fleetDeliveryAgentList, setFleetDeliveryAgentList] = useState([]);
  const [fleetPickupAgentList, setFleetPickupAgentList] = useState([]);
  const [systemUserData, setSystemUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState(null);
  const [getBookingExtensionDetails, setBookingExtensionDetails] =
    useState(null);
  const [getBookingReschduleDetails, setBookingRescheduleDetails] =
    useState(null);
  const [vehicelSwappingDetails, setVehicleSwappingDetails] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [bookingCancellationDetails, setBookingCancellationDetails] =
    useState(null);
  const [ticketDetails, setTicketDetails] = useState(null);
  const [getUploadedImagesData, setGetUploadedImagesData] = useState([]);
  const actionsToAccess = getactions(profile?.roles, profile?.actions);
  const [firstLoading, setFirstLoading] = useState(false);
  const [bookingComments, setBookingComments] = useState([]);
  const [aiSummarizedResult, setAiSummarizedResult] = useState([]);
  const [aiSummarizeLoading, setAiSummarizeLoading] = useState(false);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(720); // Default width
  const [isResizing, setIsResizing] = useState(false);

  const [showSemanticContext, setShowSemanticContext] = useState(false);
  const [aiSummaryText, setAiSummaryText] = useState(null);
  const [isAiLoading, setIsAiLoading] = useState(false);
  const [highlightedField, setHighlightedField] = useState(null);
  const tabContentRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizing) return;
      // Calculate new width (distance from mouse X to right edge of screen)
      const newWidth = window.innerWidth - e.clientX;

      // Bound the slider between 400px (min) and 90% of screen width (max)
      if (newWidth >= 400 && newWidth <= window.innerWidth * 0.9) {
        setDrawerWidth(newWidth);
      }
    };

    const handleMouseUp = () => {
      setIsResizing(false);
    };

    if (isResizing) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      // Prevent text selection while dragging
      document.body.style.userSelect = "none";
    } else {
      document.body.style.userSelect = "";
    }

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.body.style.userSelect = "";
    };
  }, [isResizing]);

  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsResizing(true);
  };

  const handleNavigateToTarget = ({ tabId, accordionId, fieldLabel }) => {
    if (accordionId) {
      const el = document.getElementById(accordionId);
      if (el) {
        // 1. Scroll the accordion into view
        el.scrollIntoView({ behavior: "smooth", block: "center" });

        // 2. Find the MUI AccordionSummary header or button and click it if not already open
        const summaryHeader = el.querySelector(".MuiAccordionSummary-root");
        if (
          summaryHeader &&
          summaryHeader.getAttribute("aria-expanded") !== "true"
        ) {
          summaryHeader.click();
        }

        // 3. Highlight animation
        el.classList.add("ring-2", "ring-blue-500", "transition-all");
        setTimeout(() => el.classList.remove("ring-2", "ring-blue-500"), 2000);
        return;
      }
    }

    if (tabId) {
      setActiveTab(tabId);
      if (fieldLabel) {
        setHighlightedField(fieldLabel);
      }
      setTimeout(() => {
        if (tabContentRef.current) {
          tabContentRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  };

  useEffect(() => {
    if (highlightedField) {
      const timer = setTimeout(() => {
        setHighlightedField(null);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [highlightedField]);

  const fleetDeliveryAgentBooking = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/fleetdeliveryagentbookings?bookingId=${id}`,
        { method: "GET" },
      );
      const data = await response.json();
      if (data?.statusCode === "0100")
        setFleetDeliveryAgentList(data?.entities?.rows);
      return data;
    } catch (error) {
      console.error("Error fetching Delivery Agents:", error);
    }
  };

  const fleetPickupAgentBooking = async (bookingId) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/fleetpickupagentbookings?bookingId=${bookingId}`,
        { method: "GET" },
      );
      const data = await response.json();
      if (data?.statusCode === "0100")
        setFleetPickupAgentList(data?.entities?.rows);
      return data;
    } catch (error) {
      console.error("Error fetching Pickup Agents:", error);
    }
  };

  const getEndDetails = async (bookingId) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/tripenddetails?bookingId=${bookingId}`,
        { method: "GET" },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") setTripEndDetails(data?.entities?.rows);
      return data;
    } catch (error) {
      console.error("Error fetching trip end details:", error);
    }
  };

  const getTripDetails = async (bookingId) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/tripstartdetails?bookingId=${bookingId}`,
        { method: "GET" },
      );
      const data = await response.json();
      if (data?.statusCode === "0100")
        setTripStartDetails(data?.entities?.rows);
      return data;
    } catch (error) {
      console.error("Error fetching trip start details:", error);
    }
  };

  const getBookingDetail = async (Code, type) => {
    let query =
      type === "booking" ? `&bookingCode=${Code}` : `&inquiryCode=${Code}`;
    setFirstLoading(true);
    try {
      const response = await fetch(`${apiUrl}/api/vehiclebookings?${query}`, {
        method: "GET",
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const bookingData = data?.entities?.rows[0];
        setFirstLoading(false);
        setBookingId(bookingData.id);
        setSummaryDetails(bookingData);
        getVehicleDetial(bookingData.vehicleId);
        paymentDetails(bookingData.id);
        fareBreakUpDetails(bookingData.id);
        getTripDetails(bookingData.id);
        getEndDetails(bookingData.id);
        getVehicleDocuments(bookingData.vehicleId);
      }
      return data;
    } catch (error) {
      console.error("Error fetching Booking Detail:", error);
      return null;
    }
  };

  const getVehicleDetial = async (vehicleId) => {
    try {
      const response = await fetch(`${apiUrl}/api/vehicles/${vehicleId}`, {
        method: "GET",
      });
      const data = await response.json();
      if (data) setVehicleDetials(data?.entityValue);
      return data;
    } catch (error) {
      console.error("Error fetching vehicle details:", error);
    }
  };

  const getVehicleDocuments = async (explicitVehicleId) => {
    const vehicleId = explicitVehicleId || summaryDetails?.vehicleId;
    try {
      const response = await fetch(
        `${apiUrl}/api/documents?limit=100&resourceType=${resourceTypes?.inverted?.vehicles}&resourceId=${vehicleId}&isReminderSet=${true}`,
        { method: "GET" },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") setDocuments(data?.entities?.rows);
      return data;
    } catch (error) {
      console.error("Error fetching vehicle documents:", error);
    }
  };

  const fareBreakUpDetails = async (bookingId) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/bookingtransactions?bookingId=${bookingId}`,
        { method: "GET" },
      );
      const data = await response.json();
      if (data?.statusCode === "0100")
        setTransactionDetails(data?.entities?.rows);
      return data;
    } catch (error) {
      console.error("Error fetching Payment Details:", error);
    }
  };

  const paymentDetails = async (bookingId) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehiclebookings/${bookingId}`,
        { method: "GET" },
      );
      const data = await response.json();
      if (data) setPaymentDetailsData(data?.entityValue);
      return data;
    } catch (error) {
      console.error("Error fetching Payment Details:", error);
    }
  };

  const bookingExtensionDetails = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/dailyrentalextensions?limit=100&bookingId=${id}`,
        { method: "GET" },
      );
      const data = await response.json();
      if (data?.statusCode === "0100")
        setBookingExtensionDetails(data?.entities?.rows);
      return data;
    } catch (error) {
      console.error("Error fetching extension details:", error);
    }
  };

  const getVehicleWappingDetails = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/fleetbookingswappings?limit=100&bookingId=${id}`,
        { method: "GET" },
      );
      const data = await response.json();
      if (data?.statusCode === "0100")
        setVehicleSwappingDetails(data?.entities?.rows);
      return data;
    } catch (error) {
      console.error("Error fetching swap details:", error);
    }
  };

  const bookingRescheduleDetails = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/seldrivebookingreschedulings?limit=100&bookingId=${id}`,
        { method: "GET" },
      );
      const data = await response.json();
      if (data?.statusCode === "0100")
        setBookingRescheduleDetails(data?.entities?.rows);
      return data;
    } catch (error) {
      console.error("Error fetching reschedule details:", error);
    }
  };

  const bookingCalleationPloicies = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/cancelledbookings?bookingId=${id}`,
        { method: "GET" },
      );
      const data = await response.json();
      if (data?.statusCode === "0100")
        setBookingCancellationDetails(data?.entities?.rows);
      return data;
    } catch (error) {
      console.error("Error fetching cancellation policy:", error);
    }
  };

  const getticketDetails = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/tickets?bookingCode=${id}`, {
        method: "GET",
      });
      const data = await response.json();
      if (data?.statusCode === "0100") setTicketDetails(data?.entities?.rows);
      return data;
    } catch (error) {
      console.error("Error fetching tickets:", error);
    }
  };

  useEffect(() => {
    if (selectedRow?.bookingCode) {
      getBookingDetail(selectedRow?.bookingCode, "booking");
    } else if (selectedRow?.inquiryID) {
      getBookingDetail(selectedRow?.inquiryID, "inquiry");
    } else {
      getBookingDetail(selectedRow?.bookingId, "booking");
    }

    if (selectedRow?.id) {
      fleetDeliveryAgentBooking(selectedRow?.id);
      fleetPickupAgentBooking(selectedRow?.id);
      bookingExtensionDetails(selectedRow?.id);
      bookingRescheduleDetails(selectedRow?.id);
      getVehicleWappingDetails(selectedRow?.id);
      bookingCalleationPloicies(selectedRow?.id);
      getticketDetails(selectedRow?.bookingCode);
      getBookingComments(selectedRow?.id);
    }
  }, [selectedRow]);

  useEffect(() => {
    if (dbId) {
      getBookingDetail(queryBookingid, "booking");
      bookingExtensionDetails(dbId);
      bookingRescheduleDetails(dbId);
      getVehicleWappingDetails(dbId);
      bookingCalleationPloicies(dbId);
      getBookingComments(dbId);
      fleetDeliveryAgentBooking(dbId);
      fleetPickupAgentBooking(dbId);
    }
  }, [dbId]);

  const getTabs = () => {
    const status = summaryDetails?.bookingStatus;
    let tabs = [];

    if (String(status) === fleetBookingStatus?.inverted?.bookingConfirmed) {
      tabs.push(
        { id: "updatedetails", label: "Update Details" },
        { id: "assignagents", label: "Assign Agent" },
        { id: "trip", label: "Trip Details" },
        { id: "customer", label: "Customer" },
        { id: "vehicle", label: "Vehicle" },
        ...(actionsToAccess?.includes("Booking Modification")
          ? [
              { id: "extension", label: "Extension" },
              { id: "swapvehicle", label: "Swap Vehicle" },
              { id: "reschedulebooking", label: "Reschedule" },
              { id: "cancel", label: "Cancel" },
            ]
          : []),
        { id: "nrks", label: "NRK's" },
        { id: "images", label: "Images" },
        { id: "timeline", label: "Timeline" },
        ...(actionsToAccess?.includes("Add Booking Transactions") &&
        paymentDetailsData?.pendingAmount > 0
          ? [{ id: "addtransations", label: "Add Transactions" }]
          : []),
        { id: "bookingLineItems", label: "Booking Line Items" },
        { id: "bookingcomments", label: "Booking Comments" },
        { id: "fleetbookingcomments", label: "Fleet Booking Comments" },
      );
    }

    if (String(status) === fleetBookingStatus?.inverted?.inquiry) {
      tabs.push(
        ...(actionsToAccess?.includes("Initiate Booking")
          ? [{ id: "initiatebooking", label: "Initiate Booking" }]
          : []),
        { id: "customer", label: "Customer" },
        { id: "vehicle", label: "Vehicle" },
        ...(actionsToAccess?.includes("Add Booking Transactions") &&
        paymentDetailsData?.pendingAmount > 0
          ? [{ id: "addtransations", label: "Add Transactions" }]
          : []),
        { id: "timeline", label: "Timeline" },
        { id: "bookingcomments", label: "Booking Comments" },
      );
    }

    if (String(status) === fleetBookingStatus?.inverted?.paymentPending) {
      tabs.push(
        { id: "updatedetails", label: "Update Details" },
        { id: "customer", label: "Customer" },
        { id: "vehicle", label: "Vehicle" },
        ...((actionsToAccess?.includes("Add Booking Transactions") &&
          paymentDetailsData?.pendingAmount > 0) ||
        fleetBookingStatus?.inverted?.paymentPending === String(status)
          ? [{ id: "addtransations", label: "Add Transactions" }]
          : []),
        { id: "timeline", label: "Timeline" },
        { id: "bookingcomments", label: "Booking Comments" },
        { id: "fleetbookingcomments", label: "Fleet Booking Comments" },
      );
    }

    if (String(status) === fleetBookingStatus?.inverted?.enroute) {
      tabs.push(
        { id: "trip", label: "Trip Details" },
        { id: "assignagents", label: "Assign Agent" },
        ...(actionsToAccess?.includes("Booking Modification")
          ? [{ id: "extension", label: "Extension" }]
          : []),
        { id: "customer", label: "Customer" },
        { id: "vehicle", label: "Vehicle" },
        { id: "images", label: "Images" },
        { id: "nrks", label: "NRK's" },
        ...(actionsToAccess?.includes("Add Booking Transactions") &&
        paymentDetailsData?.pendingAmount > 0
          ? [{ id: "addtransations", label: "Add Transactions" }]
          : []),
        { id: "bookingLineItems", label: "Booking Line Items" },
        { id: "timeline", label: "Timeline" },
        { id: "bookingcomments", label: "Booking Comments" },
        { id: "fleetbookingcomments", label: "Fleet Booking Comments" },
      );
    }

    if (String(status) === fleetBookingStatus?.inverted?.documentPending) {
      tabs.push(
        { id: "customer", label: "Customer" },
        { id: "vehicle", label: "Vehicle" },
         ...(actionsToAccess?.includes("Booking Modification")
          ? [
              { id: "extension", label: "Extension" },
              { id: "swapvehicle", label: "Swap Vehicle" },
              { id: "reschedulebooking", label: "Reschedule" },
              { id: "cancel", label: "Cancel" },
            ]
          : []),
        { id: "timeline", label: "Timeline" },
        ...(actionsToAccess?.includes("Add Booking Transactionss") &&
        paymentDetailsData?.pendingAmount > 0
          ? [{ id: "addtransations", label: "Add Transactions" }]
          : []),
        { id: "bookingcomments", label: "Booking Comments" },
        { id: "fleetbookingcomments", label: "Fleet Booking Comments" },       
      );
    }

    if (String(status) === fleetBookingStatus?.inverted?.bookingRescheduled) {
      tabs.push(
        { id: "assignagents", label: "Assign Agent" },
        { id: "trip", label: "Trip Details" },
        { id: "customer", label: "Customer" },
        { id: "vehicle", label: "Vehicle" },
        { id: "nrks", label: "NRK's" },
        { id: "timeline", label: "Timeline" },
        { id: "images", label: "Images" },
        ...(actionsToAccess?.includes("Add Booking Transactions") &&
        paymentDetailsData?.pendingAmount > 0
          ? [{ id: "addtransations", label: "Add Transactions" }]
          : []),
        { id: "bookingLineItems", label: "Booking Line Items" },
        { id: "bookingcomments", label: "Booking Comments" },
        { id: "fleetbookingcomments", label: "Fleet Booking Comments" },
        ...(actionsToAccess?.includes("Booking Modification")
          ? [
              { id: "extension", label: "Extension" },
              { id: "swapvehicle", label: "Swap Vehicle" },
              { id: "reschedulebooking", label: "Reschedule" },
              { id: "cancel", label: "Cancel" },
            ]
          : []),
      );
    }

    if (String(status) === fleetBookingStatus?.inverted?.bookingClosed) {
      tabs.push(
        { id: "assignagents", label: "Assign Agent" },
        { id: "trip", label: "Trip Details" },
        { id: "customer", label: "Customer" },
        { id: "vehicle", label: "Vehicle" },
        { id: "nrks", label: "NRK's" },
        { id: "timeline", label: "Timeline" },
        { id: "images", label: "Images" },
        { id: "bookingLineItems", label: "Booking Line Items" },
        { id: "bookingcomments", label: "Booking Comments" },
        { id: "fleetbookingcomments", label: "Fleet Booking Comments" },
      );
    }

    if (String(status) === fleetBookingStatus?.inverted?.cancelled) {
      tabs.push(
        { id: "customer", label: "Customer" },
        { id: "timeline", label: "Timeline" },
        { id: "vehicle", label: "Vehicle" },
        { id: "bookingcomments", label: "Booking Comments" },
        { id: "fleetbookingcomments", label: "Fleet Booking Comments" },
      );
    }

    if (String(status) === fleetBookingStatus?.inverted?.refundPending) {
      tabs.push(
        { id: "customer", label: "Customer" },
        { id: "vehicle", label: "Vehicle" },
        { id: "trip", label: "Trip Details" },
        { id: "nrks", label: "NRK's" },
        { id: "timeline", label: "Timeline" },
        { id: "images", label: "Images" },
        { id: "bookingLineItems", label: "Booking Line Items" },
        { id: "bookingcomments", label: "Booking Comments" },
        { id: "fleetbookingcomments", label: "Fleet Booking Comments" },
      );
    }

    if (String(status) === fleetBookingStatus?.inverted?.inquiryClosed) {
      tabs.push(
        { id: "customer", label: "Customer" },
        { id: "vehicle", label: "Vehicle" },
        { id: "timeline", label: "Timeline" },
        { id: "bookingcomments", label: "Booking Comments" },
      );
    }

    if (String(status) === fleetBookingStatus?.inverted?.verificationPending) {
      tabs.push(
        { id: "customer", label: "Customer" },
        { id: "vehicle", label: "Vehicle" },
        { id: "timeline", label: "Timeline" },
        ...(actionsToAccess?.includes("Add Booking Transactions") &&
        paymentDetailsData?.pendingAmount > 0
          ? [{ id: "addtransations", label: "Add Transactions" }]
          : []),
        ...(actionsToAccess?.includes("Booking Modification")
          ? [{ id: "cancel", label: "Cancel" }]
          : []),
        { id: "bookingLineItems", label: "Booking Line Items" },
        { id: "bookingcomments", label: "Booking Comments" },
        { id: "fleetbookingcomments", label: "Fleet Booking Comments" },
      );
    }

    if (String(status) === fleetBookingStatus?.inverted?.tripCompleted) {
      tabs.push(
        { id: "bookingLineItems", label: "Booking Line Items" },
        { id: "trip", label: "Trip Details" },
        { id: "customer", label: "Customer" },
        { id: "vehicle", label: "Vehicle" },
        { id: "nrks", label: "NRK's" },
        { id: "images", label: "Images" },
        { id: "timeline", label: "Timeline" },
        ...(actionsToAccess?.includes("Add Booking Transactions") &&
        paymentDetailsData?.pendingAmount > 0
          ? [{ id: "addtransations", label: "Add Transactions" }]
          : []),
        { id: "bookingcomments", label: "Booking Comments" },
        { id: "fleetbookingcomments", label: "Fleet Booking Comments" },
      );
    }

    if (String(status) === fleetBookingStatus?.inverted?.bookingExtented) {
      tabs.push(
        { id: "assignagents", label: "Assign Agent" },
        { id: "trip", label: "Trip Details" },
        { id: "customer", label: "Customer" },
        { id: "vehicle", label: "Vehicle" },
        { id: "nrks", label: "NRK's" },
        { id: "images", label: "Images" },
        { id: "timeline", label: "Timeline" },
        ...(actionsToAccess?.includes("Add Booking Transactions") &&
        paymentDetailsData?.pendingAmount > 0
          ? [{ id: "addtransations", label: "Add Transactions" }]
          : []),
        { id: "bookingLineItems", label: "Booking Line Items" },
        { id: "bookingcomments", label: "Booking Comments" },
        { id: "fleetbookingcomments", label: "Fleet Booking Comments" },
        ...(actionsToAccess?.includes("Booking Modification")
          ? [
              { id: "extension", label: "Extension" },
              { id: "swapvehicle", label: "Swap Vehicle" },
              { id: "reschedulebooking", label: "Reschedule" },
              { id: "cancel", label: "Cancel" },
            ]
          : []),
      );
    }

    return tabs;
  };

  useEffect(() => {
    const tabs = getTabs();
    if (tabs.length > 0) setActiveTab(tabs[0].id);
  }, [summaryDetails]);

  useEffect(() => {
    fetchcity().then((response) => {
      if (response) setCities(response);
    });
  }, []);

  const getUploadedImages = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/bookingimages?bookingId=${summaryDetails?.id}`,
        { method: "GET" },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setGetUploadedImagesData(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      console.error("Error fetching uploaded images:", error);
    }
  };

  const getBookingComments = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/bookingcomments?limit=1000&bookingId=${id}`,
        { method: "GET" },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const sorted = data?.entities?.rows.sort(
          (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
        );
        setBookingComments(sorted);
      }
      return data;
    } catch (error) {
      console.error("Error fetching booking comments:", error);
    }
  };

  const getAISummarizedResultAPI = async () => {
    if (bookingComments.length > 0) {
      setAiSummarizeLoading(true);
      try {
        const response = await fetch(
          `${apiUrl}/api/aiserverless/summarize-booking-comments`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `${token}`,
            },
            body: JSON.stringify({ commentArrays: bookingComments || [] }),
          },
        );

        if (!response.ok) {
          toast.error("Current Wnet Down please try again later");
          setAiSummarizeLoading(false);
        }

        const data = await response.json();
        if (data?.statusCode === "0100")
          setAiSummarizedResult(data?.dataValues);
        else toast.error(data?.msg);

        return data;
      } catch (error) {
        console.error("Error fetching AI summary:", error);
      } finally {
        setAiSummarizeLoading(false);
      }
    } else {
      toast.error("No Booking Comments is available");
    }
  };

  useEffect(() => {
    if (summaryDetails?.id) getUploadedImages();
  }, [summaryDetails]);

  // Dynamic composition of booking details inside useMemo (swapped transactionDetails for paymentDetailsData breakup)
  const enrichedBookingData = useMemo(() => {
    if (!summaryDetails) return null;

    return {
      ...summaryDetails,
      _vehicleDetails: vehicleDetails,
      _fareBreakup: paymentDetailsData?.fareBreakUp || [],
      _deliveryAgents: fleetDeliveryAgentList,
      _pickupAgents: fleetPickupAgentList,
      _tripStart: tripStartDetails,
      _tripEnd: tripEndDetails,
      _images: getUploadedImagesData,
      _comments: bookingComments,
      _extensions: getBookingExtensionDetails,
      _swaps: vehicelSwappingDetails,
      _reschedules: getBookingReschduleDetails,
      _cancellations: bookingCancellationDetails,
      _tickets: ticketDetails,
      _payment: paymentDetailsData,
      _documents: documents,
      _transaction: paymentDetailsData?.bookingTransactions || null,
      _customerDocuments: paymentDetailsData?.customerDocuments || [],
      _deliveryAgent: paymentDetailsData?.fleetDeliveryAgentBookings || null,
    };
  }, [
    summaryDetails,
    vehicleDetails,
    paymentDetailsData,
    fleetDeliveryAgentList,
    fleetPickupAgentList,
    tripStartDetails,
    tripEndDetails,
    getUploadedImagesData,
    bookingComments,
    getBookingExtensionDetails,
    vehicelSwappingDetails,
    getBookingReschduleDetails,
    bookingCancellationDetails,
    ticketDetails,
    documents,
  ]);

  const detectBookingRisk = async () => {
    setIsAiLoading(true);
    try {
      if (!enrichedBookingData) {
        toast.error("No booking data available");
        setIsAiLoading(false);
        return;
      }

      const result = mapBookingToSemanticContext(enrichedBookingData);
      if (result.context.startsWith("ERROR:")) {
        toast.error("Could not parse booking data");
        setIsAiLoading(false);
        return;
      }

      const prompt = `Booking record (compressed):\n${result.context}\n\nFlag anything unusual: pricing mismatch, deposit risk, or logistics issue. One line.`;

      const response = await fetch(
        `https://generativelanguage.googleapis.com/v1beta/models/gemini-3.1-flash-lite:generateContent?key=${GEMINI_API_KEY}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ contents: [{ parts: [{ text: prompt }] }] }),
        },
      );

      const geminiData = await response.json();
      if (geminiData.candidates && geminiData.candidates.length > 0) {
        const riskMessage = geminiData.candidates[0].content.parts[0].text;
        toast.success(`Risk Check: ${riskMessage}`, {
          duration: 6000,
          position: "top-center",
          style: {
            background: "#1e293b",
            color: "#f8fafc",
            padding: "16px 24px",
            borderRadius: "12px",
            fontSize: "14px",
            fontWeight: "500",
            boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
            border: "1px solid rgba(255,255,255,0.1)",
            maxWidth: "600px",
          },
        });
      } else {
        toast.error("No risk analysis received");
      }
    } catch (error) {
      console.error("Risk detection failed:", error);
      toast.error("Failed to detect risks. Please try again.");
    } finally {
      setIsAiLoading(false);
    }
  };

  const generateBookingSummary = async () => {
    setIsAiLoading(true);
    try {
      if (!enrichedBookingData) {
        toast.error("No booking data available");
        setIsAiLoading(false);
        return;
      }

      const result = mapBookingToSemanticContext(enrichedBookingData);
      if (result.context.startsWith("ERROR:")) {
        toast.error("Could not parse booking data");
        setIsAiLoading(false);
        return;
      }

      const prompt = `Booking record (compressed):\n${result.context}\n\nFlag anything unusual: pricing mismatch, deposit risk, or logistics issue. One line.`;

      const response = await fetch(
        `https://generativelanguage.googleapis.com/v1beta/models/gemini-3.1-flash-lite:generateContent?key=${GEMINI_API_KEY}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ contents: [{ parts: [{ text: prompt }] }] }),
        },
      );

      const data = await response.json();
      if (data.candidates && data.candidates.length > 0) {
        const aiResponse = data.candidates[0].content.parts[0].text;
        setAiSummaryText(aiResponse);
        toast.success("AI analysis complete!");
      } else {
        toast.error("AI returned an empty response.");
      }
    } catch (error) {
      console.error("AI Request Failed:", error);
      toast.error("Failed to generate insights");
    } finally {
      setIsAiLoading(false);
    }
  };

  return (
    <div id="bookingdetailstabid">
      <div className="max-w-screen-2xl mx-auto py-4 h-screen overflow-y-scroll scrollbar-hide text-gray-900">
        {/* Header */}
        <div className="bg-gradient-to-r from-gray-800 to-gray-700 text-white p-6 rounded-t-2xl flex flex-col md:flex-row justify-between items-start md:items-center gap-4 shadow-lg">
          <div>
            <h1 className="text-2xl font-bold">
              Inquiry Code - {summaryDetails?.inquiryCode || "N/A"} <br />
              Booking Code - {summaryDetails?.bookingCode || "N/A"} <br/>
              Booking Type - {bookingTypes[summaryDetails?.bookingType] || bookingTypes[bookingTypes?.inverted?.dailyRental]} <br/>
            </h1>
            <p className="text-sm opacity-80">
              Generated on{" "}
              {formatDateAndTime(summaryDetails?.createdAt) || "N/A"}
            </p>
          </div>
          <div className="flex gap-3 flex-wrap">
            <button
              onClick={() => {
                getBookingDetail(selectedRow?.inquiryID, "inquiry");
                bookingExtensionDetails(selectedRow?.id);
                bookingRescheduleDetails(selectedRow?.id);
                getVehicleWappingDetails(selectedRow?.id);
                bookingCalleationPloicies(selectedRow?.id);
                getticketDetails(selectedRow?.bookingCode);
                fleetDeliveryAgentBooking(selectedRow?.id);
                fleetPickupAgentBooking(selectedRow?.id);
                getBookingComments(selectedRow?.id);
              }}
              className="bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold py-3 px-6 rounded-full shadow-lg flex items-center transition duration-300 transform hover:scale-105 active:scale-95"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100"
                height="100"
                viewBox="0 0 30 30"
                className="w-8 h-8"
              >
                <path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z"></path>
              </svg>
            </button>

            <button
              onClick={() => {
                setOpenTab(false);
                window.history.replaceState({}, "", window.location.pathname);
              }}
              className="bg-white text-center w-56 rounded-2xl h-14 relative text-black text-xl font-semibold group"
              type="button"
            >
              <div className="bg-green-400 rounded-xl h-12 w-1/4 flex items-center justify-center absolute left-1 top-[4px] group-hover:w-[194px] z-10 duration-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1024 1024"
                  height="25px"
                  width="25px"
                >
                  <path
                    d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"
                    fill="#000000"
                  ></path>
                  <path
                    d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"
                    fill="#000000"
                  ></path>
                </svg>
              </div>
              <p className="translate-x-2">Go Back</p>
            </button>
          </div>
        </div>

        <Box sx={{ borderTop: "1px solid #e5e7eb", flexShrink: 0 }}>
          <Box
            onClick={() => setShowSemanticContext(!showSemanticContext)}
            sx={{
              width: "100%",
              px: 3,
              py: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
              "&:hover": { bgcolor: "#f9fafb" },
            }}
          >
            <Typography
              variant="caption"
              sx={{ fontWeight: 500, color: "#6b7280" }}
            >
              📊 View Semantic Context
            </Typography>
            <Box
              sx={{
                transform: showSemanticContext
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
                transition: "transform 0.2s",
              }}
            >
              <svg
                width="16"
                height="16"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </Box>
          </Box>
          {showSemanticContext && (
            <Box sx={{ px: 3, pb: 2 }}>
              <Box
                component="pre"
                sx={{
                  fontSize: "10px",
                  color: "#4b5563",
                  bgcolor: "#f9fafb",
                  borderRadius: 1,
                  p: 1.5,
                  fontFamily: "monospace",
                  whiteSpace: "pre-wrap",
                  border: "1px solid #e5e7eb",
                  maxHeight: 120,
                  overflowY: "auto",
                }}
              >
                {(() => {
                  const result = mapBookingToSemanticContext(
                    enrichedBookingData || summaryDetails,
                  );
                  return typeof result === "object" &&
                    result !== null &&
                    result.context
                    ? result.context
                    : "No context available";
                })()}
              </Box>
            </Box>
          )}
        </Box>

        {/* ===== AI DRAWER - Right Side ===== */}
        {summaryDetails && (
          <>
            <Fab
              onClick={() => setIsDrawerOpen(true)}
              aria-label="Open AI Chat Assistant"
              sx={{
                position: "fixed",
                right: 0,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 40,
                bgcolor: "white",
                color: "black",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                "&:hover": {
                  transform: "translateY(-50%) scale(1.05)",
                  bgcolor: "white",
                },
                width: "auto",
                height: "auto",
                padding: "12px 10px",
                flexDirection: "column",
                gap: "4px",
                borderRadius: "8px 0 0 8px",
                border: "1px solid #e5e7eb",
                borderRight: "none",
                transition: "all 0.3s ease",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <Box sx={{ position: "relative" }}>
                  <img
                    src={Aigif}
                    alt="AI Icon"
                    style={{ width: 24, height: 24 }}
                  />
                  {/* <Box sx={{ position: 'absolute', top: -2, right: -2, width: 8, height: 8, bgcolor: '#34d399', borderRadius: '50%', animation: 'pulse 2s infinite' }} /> */}
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "10px",
                    fontWeight: 600,
                    display: { xs: "none", sm: "block" },
                    color: "black",
                  }}
                >
                  AI Chat
                </Typography>
              </Box>
            </Fab>

            <Drawer
              anchor="right"
              open={isDrawerOpen}
              onClose={() => setIsDrawerOpen(false)}
              sx={{
                "& .MuiDrawer-paper": {
                  width: { xs: "100%", sm: drawerWidth },
                  maxWidth: "100vw",
                  bgcolor: "white",
                  boxShadow: "0 0 40px rgba(0,0,0,0.2)",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                },
              }}
            >
              {/* 👉 DRAGGABLE SLIDER HANDLE */}
              <Box
                onMouseDown={handleMouseDown}
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  bottom: 0,
                  width: "6px",
                  cursor: "ew-resize",
                  bgcolor: isResizing ? "#6366f1" : "transparent",
                  "&:hover": { bgcolor: "#818cf8" },
                  zIndex: 100,
                  transition: "background-color 0.2s",
                  display: { xs: "none", sm: "block" },
                }}
              />

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justify: "space-between",
                  px: 3,
                  py: 2,
                  background: "linear-gradient(135deg, #6366f1, #a855f7)",
                  color: "white",
                  flexShrink: 0,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    minWidth: 0,
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: 1,
                      bgcolor: "rgba(255,255,255,0.2)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <ChatIcon sx={{ fontSize: 20 }} />
                  </Box>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: 600,
                        fontSize: "0.95rem",
                        noWrap: true,
                      }}
                    >
                      AI Booking Assistant
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ opacity: 0.8, noWrap: true }}
                    >
                      {summaryDetails?.bookingCode || "Booking"} • Live
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flexShrink: 0,
                  }}
                >
                  <Chip
                    size="small"
                    label="Live"
                    sx={{
                      bgcolor: "rgba(255,255,255,0.2)",
                      color: "white",
                      "& .MuiChip-label": {
                        fontSize: "10px",
                        fontWeight: 600,
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                      },
                    }}
                    icon={
                      <Box
                        sx={{
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          bgcolor: "#34d399",
                          animation: "pulse 2s infinite",
                        }}
                      />
                    }
                  />
                  <IconButton
                    onClick={() => setIsDrawerOpen(false)}
                    sx={{
                      color: "white",
                      "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
                    }}
                    size="small"
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Box>

              {(aiSummaryText || isAiLoading) && (
                <Box
                  sx={{
                    px: 3,
                    py: 2,
                    bgcolor: "#f0fdf4",
                    borderBottom: "1px solid #e5e7eb",
                    flexShrink: 0,
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 600,
                      color: "#065f46",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <span>🤖</span> AI Insights
                  </Typography>
                  {isAiLoading ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        mt: 1,
                      }}
                    >
                      <CircularProgress size={20} />
                      <Typography variant="body2" color="text.secondary">
                        Analyzing booking data...
                      </Typography>
                    </Box>
                  ) : (
                    <Typography
                      variant="body2"
                      sx={{ mt: 1, color: "#065f46" }}
                    >
                      {aiSummaryText}
                    </Typography>
                  )}
                </Box>
              )}

              <Box
                sx={{
                  flex: 1,
                  minHeight: 0,
                  display: "flex",
                  overflow: "hidden",
                  bgcolor: "#f9fafb",
                }}
              >
                {!summaryDetails ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <CircularProgress />
                  </Box>
                ) : (
                  <FleetChat
                    bookings={enrichedBookingData || summaryDetails}
                    geminiApiKey={GEMINI_API_KEY}
                    onNavigateToTarget={handleNavigateToTarget}
                  />
                )}
              </Box>
            </Drawer>
          </>
        )}

        {firstLoading ? (
          <div className="flex flex-col items-center h-40 justify-center">
            <BlinkBlur color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]} />
          </div>
        ) : (
          <>
            <div>
              <Summary
                paymentDetailsData={paymentDetailsData}
                vehicleDetails={vehicleDetails}
                summaryDetails={summaryDetails}
                transactionDetails={transactionDetails}
                from="booking"
                selectedRow={selectedRow}
                setActiveTab={setActiveTab}
                systemUserData={systemUserData}
                setSystemUserData={setSystemUserData}
                getBookingExtensionDetails={getBookingExtensionDetails}
                setBookingExtensionDetails={setBookingExtensionDetails}
                getBookingReschduleDetails={getBookingReschduleDetails}
                setBookingRescheduleDetails={setBookingRescheduleDetails}
                vehicelSwappingDetails={vehicelSwappingDetails}
                setVehicleSwappingDetails={setVehicleSwappingDetails}
                bookingCancellationDetails={bookingCancellationDetails}
                setBookingCancellationDetails={setBookingCancellationDetails}
                ticketDetails={ticketDetails}
                setTicketDetails={setTicketDetails}
                cities={cities}
                getAllHubsListData={getAllHubsListData}
                getAllBookings={getAllBookings}
                setOpenTab={setOpenTab}
                getBookingDetail={getBookingDetail}
                setActiveItem={setActiveItem}
                bookingComments={bookingComments}
                getAISummarizedResultAPI={getAISummarizedResultAPI}
                aiSummarizeLoading={aiSummarizeLoading}
                aiSummarizedResult={aiSummarizedResult}
              />
            </div>

            <div className="block md:hidden mt-4">
              <select
                value={activeTab}
                onChange={(e) => setActiveTab(e.target.value)}
                className="border border-gray-300 rounded-md p-2 w-full"
              >
                {getTabs().map((tab) => (
                  <option key={tab.id} value={tab.id}>
                    {tab.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex mt-4">
              <div className="w-48 bg-gray-100 border-r border-gray-300 hidden md:block">
                {getTabs().map((tab) => (
                  <div
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`cursor-pointer px-4 py-3 font-semibold border-l-4 ${activeTab === tab.id ? "bg-blue-100 border-blue-600 text-blue-600" : "border-transparent text-gray-600 hover:bg-blue-50"}`}
                  >
                    {tab.label}
                  </div>
                ))}
              </div>

              {/* Tab Content Panels */}
              <div
                ref={tabContentRef}
                className="flex-1 bg-white p-4 shadow-xl rounded-r-2xl"
              >
                {activeTab === "updatedetails" && (
                  <Updatedetails
                    summaryDetails={summaryDetails}
                    getBookingDetail={getBookingDetail}
                    getAllBookings={getAllBookings}
                    setOpenTab={setOpenTab}
                  />
                )}
                {activeTab === "initiatebooking" && (
                  <Initiatebooking
                    paymentDetailsData={paymentDetailsData}
                    vehicleDetails={vehicleDetails}
                    summaryDetails={summaryDetails}
                    fleetDeliveryAgentList={fleetDeliveryAgentList}
                    getBookingDetail={getBookingDetail}
                    selectedRow={selectedRow}
                    paymentDetails={paymentDetails}
                    fareBreakUpDetails={fareBreakUpDetails}
                    from="booking"
                    setActiveItem={setActiveItem}
                  />
                )}
                {activeTab === "swapvehicle" && (
                  <Swapvehicle
                    paymentDetailsData={paymentDetailsData}
                    vehicleDetails={vehicleDetails}
                    summaryDetails={summaryDetails}
                    getBookingDetail={getBookingDetail}
                    cities={cities}
                    getVehicleWappingDetails={getVehicleWappingDetails}
                    transactionDetails={transactionDetails}
                  />
                )}
                {activeTab === "extension" && (
                  <Extension
                    paymentDetailsData={paymentDetailsData}
                    vehicleDetails={vehicleDetails}
                    summaryDetails={summaryDetails}
                    getBookingDetail={getBookingDetail}
                    setActiveTab={setActiveTab}
                    selectedRow={selectedRow}
                    cities={cities}
                    bookingExtensionDetails={bookingExtensionDetails}
                  />
                )}
                {activeTab === "reschedulebooking" && (
                  <Reschedule
                    paymentDetailsData={paymentDetailsData}
                    vehicleDetails={vehicleDetails}
                    summaryDetails={summaryDetails}
                    getBookingDetail={getBookingDetail}
                    selectedRow={selectedRow}
                    cities={cities}
                    bookingRescheduleDetails={bookingRescheduleDetails}
                    fleetDeliveryAgentList={fleetDeliveryAgentList}
                    fleetDeliveryAgentBooking={fleetDeliveryAgentBooking}
                  />
                )}
                {activeTab === "trip" && (
                  <Tripstartenddetails
                    tripEndDetails={tripEndDetails}
                    tripStartDetails={tripStartDetails}
                    summaryDetails={summaryDetails}
                    vehicleDetails={vehicleDetails}
                    fleetDeliveryAgentList={fleetDeliveryAgentList}
                  />
                )}
                {activeTab === "customer" && (
                  <Customerdetails
                    summaryDetails={summaryDetails}
                    vehicleDetails={vehicleDetails}
                    getBookingDetail={getBookingDetail}
                    systemUserData={systemUserData}
                    refresh={selectedRow}
                  />
                )}
                {activeTab === "vehicle" && (
                  <div>
                    <div className="md:p-6">
                      <h2 className="text-2xl font-semibold text-[#2c3e50] mb-8">
                        Vehicle Details
                      </h2>
                      <SectionTable
                        title="Basic Information"
                        highlightLabel={highlightedField}
                        rows={[
                          [
                            "Registration Number",
                            vehicleDetails?.licensePlate || "N/A",
                          ],
                          ["Make & Model", vehicleDetails?.name || "N/A"],
                          [
                            "Vehicle Type",
                            vehicleBodyType[vehicleDetails?.vehicleBodyType] ||
                              "N/A",
                          ],
                          [
                            "Seating Capacity",
                            `${vehicleDetails?.seater ? vehicleDetails?.seater + " Passengers" : "N/A"}`,
                          ],
                          [
                            "Transmission",
                            transmissionType[
                              vehicleDetails?.transmissionType
                            ] || "N/A",
                          ],
                          [
                            "Fuel Type",
                            fuelType[vehicleDetails?.fuelType] || "N/A",
                          ],
                          [
                            "Current Status",
                            <span
                              className={`${vehicleStatus[vehicleDetails?.status] ? "bg-green-500 text-white" : "bg-yellow-100 text-yellow-800"} font-semibold px-2 py-1 rounded`}
                            >
                              {vehicleStatus[vehicleDetails?.status] || "N/A"}
                            </span>,
                          ],
                        ]}
                      />
                    </div>
                    <div className="md:p-6">
                      <h2 className="text-2xl font-semibold text-[#2c3e50] mb-8">
                        Vehicle Documents
                      </h2>
                      <Vehicledocuments summaryDetails={summaryDetails} />
                    </div>
                  </div>
                )}
                {activeTab === "charges" && (
                  <div className="p-6">
                    <h2 className="text-2xl font-semibold text-[#2c3e50] mb-8">
                      Payment Details
                    </h2>
                    <InfoTable
                      title="Payment Information"
                      highlightLabel={highlightedField}
                      rows={[
                        [
                          "Payment Method",
                          transactionDetails[0]?.paymentMode || "N/A",
                        ],
                        [
                          "Payment Status",
                          <span className="text-green-700 font-semibold">
                            N/A
                          </span>,
                        ],
                        ["Transaction ID", "N/A"],
                        [
                          "Payment Date",
                          (transactionDetails[0]?.transactionDate &&
                            formatDateAndTime(
                              transactionDetails[0]?.transactionDate,
                            )) ||
                            "N/A",
                        ],
                        transactionDetails[0]?.paymentMode === "Online" ||
                        transactionDetails[0]?.paymentMode === "online"
                          ? ["Gateway", "Razorpay"]
                          : [],
                        ["Receipt Number", "N/A"],
                      ]}
                    />
                  </div>
                )}
                {activeTab === "images" && (
                  <div>
                    <h2 className="text-2xl font-semibold text-[#2c3e50] mb-8">
                      Booking Images & Documents
                    </h2>
                    <Suspense
                      fallback={
                        <div className="text-center py-10">
                          Loading Images...
                        </div>
                      }
                    >
                      <TripStartImagesTab
                        summaryDetails={summaryDetails}
                        fleetDeliveryAgentList={fleetDeliveryAgentList}
                        getUploadedImagesData={getUploadedImagesData}
                        loading={loading}
                        setLoading={setLoading}
                        setGetUploadedImagesData={setGetUploadedImagesData}
                        getUploadedImages={getUploadedImages}
                      />
                      <TripEndImagesTab
                        summaryDetails={summaryDetails}
                        fleetPickupAgentList={fleetPickupAgentList}
                        getUploadedImagesData={getUploadedImagesData}
                        loading={loading}
                        setLoading={setLoading}
                        setGetUploadedImagesData={setGetUploadedImagesData}
                        getUploadedImages={getUploadedImages}
                      />
                      <CustomerTripImages
                        summaryDetails={summaryDetails}
                        fleetPickupAgentList={fleetPickupAgentList}
                        getUploadedImagesData={getUploadedImagesData}
                        loading={loading}
                        setLoading={setLoading}
                        setGetUploadedImagesData={setGetUploadedImagesData}
                        getUploadedImages={getUploadedImages}
                      />
                    </Suspense>
                  </div>
                )}
                {activeTab === "timeline" && (
                  <div>
                    <Timeline summaryDetails={summaryDetails} />
                  </div>
                )}
                {activeTab === "bookingLineItems" && (
                  <div>
                    <Bookinglineitems
                      bookingId={bookingId}
                      costToCustomer={paymentDetailsData?.costToCustomer}
                      totalAmountPaid={
                        paymentDetailsData?.totalAmountPaid ??
                        paymentDetailsData?.entityValue?.totalAmountPaid
                      }
                      summaryDetails={summaryDetails}
                      setOpenTab={setOpenTab}
                      getAllBookings={getAllBookings}
                      transactionDetails={transactionDetails}
                      getBookingDetail={getBookingDetail}
                      setActiveTab={setActiveTab}
                      systemUserData={systemUserData}
                      paymentDetailsData={paymentDetailsData}
                    />
                  </div>
                )}
                {activeTab === "assignagents" && (
                  <div>
                    <Assignagents
                      bookingId={bookingId}
                      summaryDetails={summaryDetails}
                      setFleetDeliveryAgentList={setFleetDeliveryAgentList}
                      fleetDeliveryAgentList={fleetDeliveryAgentList}
                      fleetDeliveryAgentBooking={fleetDeliveryAgentBooking}
                      setFleetPickupAgentList={setFleetPickupAgentList}
                      fleetPickupAgentList={fleetPickupAgentList}
                      fleetPickupAgentBooking={fleetPickupAgentBooking}
                    />
                  </div>
                )}
                {activeTab === "addtransations" && (
                  <div>
                    <Addtransactions
                      paymentDetailsData={paymentDetailsData}
                      selectedRow={selectedRow}
                      getBookingDetail={getBookingDetail}
                      summaryDetails={summaryDetails}
                    />
                  </div>
                )}
                {activeTab === "nrks" && (
                  <div>
                    <Nrks summaryDetails={summaryDetails} />
                  </div>
                )}
                {activeTab === "bookingcomments" && (
                  <div>
                    <Comments
                      bookingComments={bookingComments}
                      setBookingComments={setBookingComments}
                      getBookingComments={getBookingComments}
                      summaryDetails={summaryDetails}
                      getAISummarizedResultAPI={getAISummarizedResultAPI}
                    />
                  </div>
                )}
                {activeTab === "fleetbookingcomments" && (
                  <div>
                    <Fleetbookingcomments
                      fleetDeliveryAgentList={fleetDeliveryAgentList}
                      fleetPickupAgentList={fleetPickupAgentList}
                      summaryDetails={summaryDetails}
                    />
                  </div>
                )}
                {activeTab === "cancel" && (
                  <div>
                    <Cancelbooking
                      paymentDetailsData={paymentDetailsData}
                      vehicleDetails={vehicleDetails}
                      summaryDetails={summaryDetails}
                      getBookingDetail={getBookingDetail}
                      selectedRow={selectedRow}
                      cities={cities}
                      bookingCalleationPloicies={bookingCalleationPloicies}
                      bookingCancellationDetails={bookingCancellationDetails}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Bookingdetailstab;
